module.exports = __webpack_public_path__ + "static/img/pcbody.1b43b63e.png";